import React, { Component } from 'react'
import { connect } from 'react-redux'
import { PostActionsHeader } from './postActionsHeader.view'
import { PostActionsList } from './postActionsList.view'

const ADMIN_ACTION_ITEM_CLASS = 'admin-dropdown-action dropdown-comp__item'

export class PostActionsContainerComponent extends Component {
  shouldRender() {
    const { optionsList, hasErrors, isLoading } = this.props
    return !isLoading && !hasErrors && optionsList && optionsList.length > 0
  }

  render() {
    const { optionsList, confirmAndExecAdminAction } = this.props
    return this.shouldRender()
      ? <div
          className="post-admin-options has-dropdown post-metadata__admin-dropdown"
          data-block-name="post-admin-options"
        >
          <div className="post-admin-options__container">
            <PostActionsHeader />
            <PostActionsList {...{ optionsList, confirmAndExecAdminAction }} />
          </div>
        </div>
      : null
  }
}

PostActionsContainerComponent.defaultProps = {
  optionsList: [],
  fetchFromServer: false,
}



// WEBPACK FOOTER //
// ./provolution/app/views/provolution/components/post_actions/postActions.container.js